/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { Component } from 'react';
import { string, func, shape, bool } from 'prop-types';
import { client, applePay, dataCollector } from 'braintree-web';
import isEqual from 'lodash/isEqual';
import { readCookie } from '@tcp/core/src/utils';
import { isApplePayEligible } from '@tcp/core/src/utils/utils';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import {
  getShippingMethods,
  setShippingMethodAndAddressId,
} from '@tcp/core/src/services/abstractors/CnC/CheckoutSFCC';
import CheckoutConstants, {
  CHECKOUT_ROUTES,
  ORDER_TYPE,
} from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import InjectLoyaltyDynamicStore from '@tcp/core/src/components/features/CnC/LoyaltyBanner/container/LoyaltyDynamicStore';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import BAGPAGE_LABELS from '../../../../features/CnC/BagPage/container/Bagpage.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import {
  getCurrentOrderFormatter,
  getCartCachedDataApplePay,
} from '../../../../../services/abstractors/SFCC/CartItemTile';
import utility from '../../../../features/CnC/Checkout/util/utility';
import {
  formatShippingMethods,
  formatShippingMethodsForBopisBoss,
  getLineItems,
  getTotal,
  getLedgerSummaryData,
  getUnqualifiedItemsCall,
  isValidShippingAddress,
  addAddressAndShippingMethod,
  verifyMellisaAddress,
  getPaySheetError,
  isCompleteContactInPaysheet,
  ErrorCodes,
  appleLabel,
  getShippingContactPayload,
  getShippingUpdatePayloadWeb,
  setAppleShippingAddressAndMethodPayload,
} from '../container/ApplePaymentButton.util';
import withStyles from '../../../hoc/withStyles';
import styles from '../styles/ApplePaymentButton.style';
import BodyCopy from '../../BodyCopy';

const getIsEcomOrder = (orderType) => {
  return (
    orderType === ORDER_TYPE.PURE_ECOM || orderType === ORDER_TYPE.ECOM_MIX || orderType === 'ECOM'
  );
};
class ApplePaymentButton extends Component {
  constructor(props) {
    super(props);
    this.shipModeId = '';
    this.deviceData = {};
    this.isMellisaValidationCompleted = false;
    this.state = {
      appleInstance: {},
    };
    this.labelsObj = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);
  }

  componentDidMount() {
    const { shipModeId, shipmentMethods, isGuest, getAddressListAction } = this.props;
    this.shipModeId = shipModeId;
    if (!isGuest) {
      getAddressListAction();
    }
    if (!(shipmentMethods && shipmentMethods.length > 0 && shipModeId)) {
      this.fetchDefaultShippingMethods();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(nextState, this.state) && isEqual(nextProps, this.props));
  }

  componentDidUpdate(prevProps) {
    const basketId = readCookie('basketId');
    if (
      basketId &&
      prevProps.createAppleInstance !== this.props.createAppleInstance &&
      this.props.createAppleInstance === true
    ) {
      this.getApplePayInstance();
    }
  }

  // Get Shipping Method API Call
  fetchShippingMethods = async (zipCode, state) => {
    const {
      basketId,
      errorLabels,
      shippingTotal,
      isDynamicFreeShippingEnabled,
      shipments,
      freeShippingThershold,
      orderType,
      productTotal,
    } = this.props;
    const payload = {
      state,
      zipCode,
      fromPage: 'applePaySheet',
    };
    const eventType =
      zipCode || state
        ? CheckoutConstants.CHANGE_SHIPMMENT_METHODS
        : CheckoutConstants.LOAD_SHIPMMENT_METHODS;
    const shipmentMethods = await getShippingMethods(payload, errorLabels, eventType, basketId);
    return formatShippingMethods(
      shipmentMethods,
      this.shipModeId,
      shippingTotal,
      isDynamicFreeShippingEnabled,
      shipments,
      freeShippingThershold,
      orderType,
      productTotal
    );
  };

  updateCartInRedux = async (orderDetails) => {
    const {
      setCartData,
      simulateLoyaltyDetail,
      defaultApplepay,
      loyaltyPointsRequestPayload = {},
    } = this.props;
    const { applePayShippingTotal } = orderDetails;
    const newOrderDetails = { ...orderDetails, appliedGiftCards: [] };
    if (defaultApplepay && newOrderDetails?.checkout?.billing) {
      newOrderDetails.checkout.billing = { paymentMethod: 'APPLE_PAY' };
    }
    setCartData({
      ...newOrderDetails,
      shippingTotal: applePayShippingTotal,
    });
    await InjectLoyaltyDynamicStore();
    simulateLoyaltyDetail({ ...loyaltyPointsRequestPayload, source: 'Cart' });
  };

  fetchDefaultShippingMethods = () => {
    const { loadShipmentMethods } = this.props;
    const requestPayload = {
      payload: {
        pageEvent: CheckoutConstants.ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION,
      },
    };
    loadShipmentMethods(requestPayload);
  };

  createPaymentRequest = (applePayInstance) => {
    this.isMellisaValidationCompleted = false;
    const {
      shippingContact,
      pageLedgerSummaryData,
      shipmentMethods,
      isEDD,
      orderEddDates,
      orderType,
      stores,
      isEddABTest,
      shippingTotal,
      isDynamicFreeShippingEnabled,
      shipments,
      freeShippingThershold,
      productTotal,
      isOptimizeApplePaySheet,
      isGuest,
      isSuppressApplePayEmailFieldEnabled,
      isRememberedUser,
    } = this.props;
    const suppressEmailField =
      (!isGuest || isRememberedUser) && isSuppressApplePayEmailFieldEnabled;

    const { orderBalanceTotal } = pageLedgerSummaryData;
    const { postalCode, administrativeArea } = shippingContact;
    const contact = postalCode || administrativeArea ? shippingContact : {};
    let payloadSpecificToOrderType = {};
    if (!isOptimizeApplePaySheet) {
      if (getIsEcomOrder(orderType)) {
        payloadSpecificToOrderType = {
          requiredShippingContactFields: suppressEmailField
            ? ['postalAddress', 'name', 'phone']
            : ['postalAddress', 'name', 'phone', 'email'],
          shippingMethods: formatShippingMethods(
            shipmentMethods,
            this.shipModeId,
            shippingTotal,
            isDynamicFreeShippingEnabled,
            shipments,
            freeShippingThershold,
            orderType,
            productTotal,
            {
              isEDD,
              orderEddDates,
              isEddABTest,
            }
          ),
          shippingType: ['shipping'],
        };
      } else {
        payloadSpecificToOrderType = {
          requiredShippingContactFields: suppressEmailField
            ? ['name', 'phone']
            : ['name', 'phone', 'email'],
          shippingMethods: formatShippingMethodsForBopisBoss(stores),
          shippingType: ['storePickup'],
        };
      }
    }

    return applePayInstance.createPaymentRequest({
      countryCode: 'US',
      currencyCode: 'USD',
      merchantCapabilities: ['supports3DS'],
      supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
      total: getTotal(orderBalanceTotal, 'final'),
      billingContact: contact,
      lineItems: getLineItems(pageLedgerSummaryData),
      requiredBillingContactFields: ['phone', 'name'],
      shippingContact: contact,
      ...payloadSpecificToOrderType,
    });
  };

  createSession = (paymentRequest) => {
    let session;
    try {
      session = new window.ApplePaySession(3, paymentRequest);
      return session;
    } catch (err) {
      return null;
    }
  };

  // eslint-disable-next-line complexity, sonarjs/cognitive-complexity
  submitPayment = (event, session, addressId, payload) => {
    const {
      submitAppleBillingSection,
      orderType,
      shippingContact,
      isOptimizeApplePaySheet,
      stores,
      bossUnavailableProducts,
    } = this.props;

    const isBossUnavailable = bossUnavailableProducts?.length > 0;

    const shippingContactDetails = isOptimizeApplePaySheet
      ? shippingContact
      : event.payment.shippingContact;
    let contact = {};
    if (getIsEcomOrder(orderType)) {
      contact = {
        address1: shippingContactDetails.addressLines[0],
        address2: shippingContactDetails.addressLines[1],
        city: shippingContactDetails.locality,
        postalCode: shippingContactDetails.postalCode,
        countryCode: shippingContactDetails.countryCode.toUpperCase(),
        stateCode: shippingContactDetails.administrativeArea.toUpperCase(),
        c_emailAddress: shippingContactDetails.emailAddress,
        firstName: shippingContactDetails.givenName,
        lastName: shippingContactDetails.familyName,
        phone: shippingContactDetails.phoneNumber,
      };
    } else {
      contact = {
        address1: isBossUnavailable
          ? stores?.[0]?.addressLine1 || shippingContact?.addressLines[0] || ''
          : shippingContact?.addressLines[0] || '',
        address2: shippingContact?.addressLines[1] || '',
        city: isBossUnavailable
          ? stores?.[0]?.city || shippingContact?.locality || ''
          : shippingContact?.locality || '',
        postalCode: isBossUnavailable
          ? stores?.[0]?.zipCode || shippingContact?.postalCode || ''
          : shippingContact?.postalCode || '',
        countryCode: isBossUnavailable
          ? stores?.[0]?.country?.toUpperCase() || shippingContact?.countryCode?.toUpperCase() || ''
          : shippingContact?.countryCode?.toUpperCase() || '',
        stateCode: isBossUnavailable
          ? stores?.[0]?.state?.toUpperCase() ||
            shippingContact?.administrativeArea?.toUpperCase() ||
            ''
          : shippingContact?.administrativeArea?.toUpperCase() || '',
        c_emailAddress: shippingContactDetails?.emailAddress || '',
        firstName: shippingContactDetails?.givenName || '',
        lastName: shippingContactDetails?.familyName || '',
        phone: shippingContactDetails?.phoneNumber || '',
      };
    }

    const requestData = {
      paymentNonce: payload.nonce,
      paymentMethod: appleLabel.APPLE_PAY,
      billingAddress: contact,
      deviceData: this.deviceData,
      saveToProfile: false,
      orderType,
    };

    submitAppleBillingSection(requestData);
    session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
  };

  handlingMelissaAndBillingInformation = (event, session, addressId, applePayInstance) => {
    const { setApplePaymentInProgressView } = this.props;
    applePayInstance.tokenize(
      {
        token: event.payment.token,
      },
      (tokenizeErr, payload) => {
        if (tokenizeErr) {
          setApplePaymentInProgressView(false);
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          return;
        }
        this.submitPayment(event, session, addressId, payload);
      }
    );
  };

  suppressMelissaForBopisAndBoss = (orderType, isOptimizeApplePaySheet) => {
    if (
      !(
        orderType === ORDER_TYPE.PURE_ECOM ||
        orderType === ORDER_TYPE.ECOM_MIX ||
        orderType === 'ECOM' ||
        isOptimizeApplePaySheet
      )
    ) {
      this.isMellisaValidationCompleted = true; // suppress melissa call in case of boss and bopis
    }
  };

  handleServiceErrors = (res, session) => {
    const { errorLabels, displayServerErrorCheckout } = this.props;
    if (res.errorCode === ErrorCodes.ERR_INVALID_CITY) {
      displayServerErrorCheckout({
        errorMessage: errorLabels.ERR_INVALID_CITY,
        component: 'Apple Pay',
      });
    } else if (res.errorCode === ErrorCodes.INCORRECT_SHIPMODE_ID) {
      displayServerErrorCheckout({
        errorMessage: res.errorMsg,
        component: 'Apple Pay',
      });
    }
    session.completePayment(window.ApplePaySession.STATUS_FAILURE);
    utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
  };

  addAddressAndPaymentAuthorization = (
    session,
    event,
    orderType,
    setCheckoutCartData,
    applePayInstance
  ) => {
    const {
      showBagLoader,
      pickUpValues,
      shipModeId,
      isOptimizeApplePaySheet,
      shippingContact,
      pickUpAlternatePerson,
    } = this.props;

    this.suppressMelissaForBopisAndBoss(orderType, isOptimizeApplePaySheet);
    verifyMellisaAddress(
      this.isMellisaValidationCompleted || isOptimizeApplePaySheet,
      event.payment.shippingContact
    ).then(async (result) => {
      const { status, errors, isMellisaValidationCompleted } = result;
      this.isMellisaValidationCompleted = isMellisaValidationCompleted;
      if (!status) {
        session.completePayment({
          status: window.ApplePaySession.STATUS_FAILURE,
          errors,
        });
      } else {
        const shippingContactPayload = getShippingContactPayload({
          event,
          orderType,
          pickUpValues,
          shipModeId,
          shippingContact,
          isOptimizeApplePaySheet,
          pickUpAlternatePerson,
        });
        const res = await addAddressAndShippingMethod(shippingContactPayload, orderType);

        if (res) {
          getCartCachedDataApplePay().then(() => {
            showBagLoader(true);
            this.handlingMelissaAndBillingInformation(
              event,
              session,
              res?.addressId,
              applePayInstance
            );
          });
        } else {
          utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
        }
      }
    });
  };

  setAppleShippingAddressAndMethod = async () => {
    const {
      shippingContact,
      shipmentMethods,
      orderType,
      pickUpValues,
      spc,
      loyaltyPointsRequestPayload = {},
      shipModeId,
      isShowAltPaymentBtn,
    } = this.props;
    if (
      shipmentMethods &&
      shipmentMethods.size !== 0 &&
      shippingContact &&
      shippingContact.emailAddress &&
      shippingContact.phoneNumber !== undefined &&
      shippingContact.phoneNumber !== null &&
      shippingContact.addressLines?.[0] &&
      shippingContact.postalCode &&
      (orderType === ORDER_TYPE.PURE_ECOM || orderType === ORDER_TYPE.ECOM_MIX) &&
      !spc &&
      !isShowAltPaymentBtn
    ) {
      const shipModeIdValue = shipModeId || shipmentMethods[0].id;
      const payload = setAppleShippingAddressAndMethodPayload(
        shippingContact,
        shipModeIdValue,
        orderType,
        pickUpValues
      );
      await addAddressAndShippingMethod(payload, orderType).then((res) => {
        if (res.data) {
          getCartCachedDataApplePay().then((cart) => {
            let resp = {};
            resp = {
              coupons: {},
              orderDetails: getCurrentOrderFormatter(cart, loyaltyPointsRequestPayload),
            };
            this.updateCartInRedux(resp.orderDetails);
            this.props.setCheckoutCartData({ res: resp });
          });
        } else {
          this.handleServiceErrors(res);
        }
      });
    }
  };

  checkMethodCondition = (res) => {
    if (res.shipments[0].shippingMethod !== null) {
      return false;
    }
    return true;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  onShippingContactSelected = (event, session) => {
    const {
      allowedApplePayStates,
      orderType,
      pickUpValues,
      loyaltyPointsRequestPayload = {},
      shippingTotal,
      isDynamicFreeShippingEnabled,
      shipments,
      freeShippingThershold,
      productTotal,
    } = this.props;
    const { postalCode, administrativeArea } = event.shippingContact;
    const { pageLedgerSummaryData, shipmentMethods } = this.props;
    const { status, errors } = isValidShippingAddress(
      allowedApplePayStates,
      event.shippingContact,
      this.isMellisaValidationCompleted
    );
    if (!status) {
      session.completeShippingContactSelection({
        newShippingMethods: formatShippingMethods(
          shipmentMethods,
          this.shipModeId,
          shippingTotal,
          isDynamicFreeShippingEnabled,
          shipments,
          freeShippingThershold,
          orderType,
          productTotal
        ),
        newTotal: getTotal(pageLedgerSummaryData.orderBalanceTotal, 'pending'),
        newLineItems: getLineItems(pageLedgerSummaryData),
        errors,
      });
    } else {
      // ***** Get Shipping Methods Based on Selected Contact */
      this.fetchShippingMethods(postalCode, administrativeArea)
        .then(async (shippingMethods) => {
          // ***** Update Selected Shipping Method */
          // const payload = shippingMethods[0].identifier;
          const shippingObject = getShippingUpdatePayloadWeb(event, orderType, pickUpValues);
          const res = await addAddressAndShippingMethod(shippingObject, orderType);

          if (res.data) {
            getCartCachedDataApplePay().then((cart) => {
              if (this.checkMethodCondition(res.data.updateShipping)) {
                this.shipModeId = shippingMethods[0].identifier;
                const payload = shippingMethods[0].identifier;
                setShippingMethodAndAddressId(payload).then((methodResp) => {
                  if (methodResp.success) {
                    getCartCachedDataApplePay().then((updatedCart) => {
                      let response = {};
                      response = {
                        coupons: {},
                        orderDetails: getCurrentOrderFormatter(
                          updatedCart,
                          loyaltyPointsRequestPayload
                        ),
                      };
                      this.updateCartInRedux(response.orderDetails);
                      const updatedPageLedgerSummaryData = getLedgerSummaryData(response);
                      session.completeShippingContactSelection(
                        window.ApplePaySession.STATUS_SUCCESS,
                        shippingMethods,
                        getTotal(updatedPageLedgerSummaryData.orderBalanceTotal, 'final'),
                        getLineItems(updatedPageLedgerSummaryData)
                      );
                    });
                  }
                });
              } else {
                let resp = {};
                resp = {
                  coupons: {},
                  orderDetails: getCurrentOrderFormatter(cart, loyaltyPointsRequestPayload),
                };
                const updatedPageLedgerSummaryData = getLedgerSummaryData(resp);
                session.completeShippingContactSelection(
                  window.ApplePaySession.STATUS_SUCCESS,
                  shippingMethods,
                  getTotal(updatedPageLedgerSummaryData.orderBalanceTotal, 'final'),
                  getLineItems(updatedPageLedgerSummaryData)
                );
              }
            });
          } else if (res.errorCode === ErrorCodes.ERR_INVALID_CITY) {
            this.handleServiceErrors(res, session);
          }
        })
        .catch((error) => {
          if (error.errorCodes === ErrorCodes.ERR_US_ZIPCODE_INVALID) {
            session.completeShippingContactSelection({
              newShippingMethods: formatShippingMethods(
                shipmentMethods,
                this.shipModeId,
                shippingTotal,
                isDynamicFreeShippingEnabled,
                shipments,
                freeShippingThershold,
                orderType,
                productTotal
              ),
              newTotal: getTotal(pageLedgerSummaryData.orderBalanceTotal, 'pending'),
              newLineItems: getLineItems(pageLedgerSummaryData),
              errors: getPaySheetError(
                'AE01',
                'AE01',
                'postalCode',
                renderLabel(
                  this.labelsObj.lbl_applepay_invalid_postal_code,
                  'lbl_applepay_invalid_postal_code'
                )
              ),
            });
          }
        });
    }
  };

  onShippingMethodSelected = (event, session) => {
    const { loyaltyPointsRequestPayload = {}, fetchCoupons } = this.props;
    // ***** Update Selected Shipping Method */
    const payload = event.shippingMethod.identifier;

    setShippingMethodAndAddressId(payload).then((res) => {
      if (res) {
        this.shipModeId = event.shippingMethod.identifier;
        // ***** Update Cart ****/
        getCartCachedDataApplePay().then((cart) => {
          let resp = {};
          resp = {
            coupons: {},
            orderDetails: getCurrentOrderFormatter(cart, loyaltyPointsRequestPayload),
          };
          this.updateCartInRedux(resp.orderDetails);
          this.props.setCheckoutCartData({ res: resp });
          const pageLedgerSummaryData = getLedgerSummaryData(resp);
          session.completeShippingMethodSelection(
            window.ApplePaySession.STATUS_SUCCESS,
            getTotal(pageLedgerSummaryData.orderBalanceTotal, 'final'),
            getLineItems(pageLedgerSummaryData)
          );
        });
        fetchCoupons({ ignoreCache: true, appliedCoupons: res.shippingMethodResp.c_couponMap });
      } else if (res.errorCode === ErrorCodes.ERR_INVALID_CITY) {
        this.handleServiceErrors(res, session);
      }
    });
  };

  onPaymentAuthorized = (event, session, applePayInstance) => {
    const {
      setApplePaymentInProgressView,
      setCheckoutCartData,
      displayServerErrorCheckout,
      orderType,
      isOptimizeApplePaySheet,
      shippingContact,
    } = this.props;
    const { statusErr, errors } = isCompleteContactInPaysheet(
      event.payment.shippingContact || shippingContact,
      isOptimizeApplePaySheet
    );

    if (!statusErr) {
      session.completePayment({
        status: 1,
        errors,
      });
    } else {
      setApplePaymentInProgressView(true);
      getUnqualifiedItemsCall().then((response) => {
        if (response && response.status) {
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          utility.routeToPage(CHECKOUT_ROUTES.bagPage);
        } else {
          this.addAddressAndPaymentAuthorization(
            session,
            event,
            orderType,
            setCheckoutCartData,
            applePayInstance,
            displayServerErrorCheckout
          );
        }
      });
    }
  };

  beginApplePay = (applePayInstance) => {
    const paymentRequest = this.createPaymentRequest(applePayInstance);
    const session = this.createSession(paymentRequest);

    session.onshippingcontactselected = (event) => {
      this.onShippingContactSelected(event, session);
    };

    session.onshippingmethodselected = (event) => {
      this.onShippingMethodSelected(event, session);
    };

    session.oncancel = () => {};

    session.onvalidatemerchant = (event) => {
      applePayInstance.performValidation(
        {
          validationURL: event.validationURL,
          displayName: "The Children's Place, Inc",
        },
        (err, merchantSession) => {
          if (err) {
            // You should show an error to the user, e.g. 'Apple Pay failed to load.'
            return;
          }
          session.completeMerchantValidation(merchantSession);
        }
      );
    };

    session.onpaymentauthorized = (event) => {
      const shippingContact = event?.payment?.shippingContact && {
        ...event?.payment?.shippingContact,
        emailAddress:
          event?.payment?.shippingContact?.emailAddress ||
          this?.props?.shippingContact?.emailAddress,
      };
      const paymentWithModifiedContact = {
        ...event?.payment,
        shippingContact,
      };

      this.onPaymentAuthorized(
        { ...event, payment: paymentWithModifiedContact },
        session,
        applePayInstance
      );
    };
    session.begin();
  };

  handleAppleInstanceError = () => {};

  getApplePayInstance = () => {
    const {
      authorizationKey,
      getIsUpdateShippingCalled,
      setIsUpdateShippingCalled,
      spc,
      createdAppleInstance,
      isShowAltPaymentBtn,
      enableUpdateCallOnInit,
    } = this.props;
    client
      .create({
        authorization: authorizationKey,
      })
      .then((clientInstance) => {
        return Promise.all([
          applePay.create({
            client: clientInstance,
          }),
          dataCollector.create({
            client: clientInstance,
            paypal: true,
          }),
        ]);
      })
      .then(([applePayInstanceRef, dataCollectorInstanceRef]) => {
        const applePayInstance = applePayInstanceRef;
        if (applePayInstance) {
          const { deviceData } = dataCollectorInstanceRef;
          const deviceDataValue = JSON.parse(deviceData);
          this.deviceData = deviceDataValue.correlation_id;
        }
        if (
          !spc &&
          !isShowAltPaymentBtn &&
          !getIsUpdateShippingCalled() &&
          enableUpdateCallOnInit
        ) {
          setIsUpdateShippingCalled();
          this.setAppleShippingAddressAndMethod();
        }
        this.setState({
          appleInstance: applePayInstance,
        });
        createdAppleInstance(true);
      })
      .catch((err) => this.handleAppleInstanceError(err));
  };

  onClickAppleButton = () => {
    this.beginApplePay(this.state.appleInstance);
    pushEventToAdobeAnalytics('payment_billing_initiate', 'applepay');
  };

  renderAppleButton = () => {
    const { className, containerId, buttonClass } = this.props;
    return (
      isApplePayEligible() && (
        <div className={className}>
          <ClickTracker
            clickData={{
              customEvents: ['event148'],
              applePayButtonLocation: 'APAY Regular Bag',
            }}
          >
            <BodyCopy
              component="div"
              fontSize="fs15"
              fontWeight="semibold"
              fontFamily="secondary"
              className={`apple-pay-button ${buttonClass}`}
              onClick={this.onClickAppleButton}
              id={containerId}
            >
              <BodyCopy
                component="span"
                fontSize="fs15"
                fontWeight="semibold"
                fontFamily="secondary"
                className="logo"
              />
            </BodyCopy>
          </ClickTracker>
        </div>
      )
    );
  };

  render() {
    return <>{this.renderAppleButton()}</>;
  }
}

ApplePaymentButton.propTypes = {
  className: string,
  authorizationKey: string,
  setApplePaymentInProgressView: func,
  submitAppleBillingSection: func,
  shippingContact: {},
  pageLedgerSummaryData: shape({}).isRequired,
  errorLabels: shape({}).isRequired,
  shipModeId: string.isRequired,
  setCartData: func.isRequired,
  setCheckoutCartData: func.isRequired,
  loadShipmentMethods: func.isRequired,
  containerId: string,
  shipmentMethods: shape([]).isRequired,
  buttonClass: string,
  allowedApplePayStates: string.isRequired,
  isEDD: bool,
  orderEddDates: shape({}),
  orderType: string.isRequired,
  stores: shape({}).isRequired,
  isEddABTest: bool,
  displayServerErrorCheckout: func.isRequired,
  basketId: string.isRequired,
  defaultApplepay: bool,
  getIsUpdateShippingCalled: func,
  setIsUpdateShippingCalled: func,
  isOptimizeApplePaySheet: bool,
};
ApplePaymentButton.defaultProps = {
  className: '',
  authorizationKey: '',
  setApplePaymentInProgressView: () => {},
  submitAppleBillingSection: () => {},
  shippingContact: {},
  containerId: '',
  buttonClass: 'apple-pay-button-white',
  isEDD: false,
  orderEddDates: {},
  isEddABTest: false,
  defaultApplepay: false,
  getIsUpdateShippingCalled: () => false,
  setIsUpdateShippingCalled: () => {},
  isOptimizeApplePaySheet: false,
};

export default withStyles(ApplePaymentButton, styles);
export { ApplePaymentButton as ApplePaymentButtonVanilla };
